import { Icon } from '@sorrem-client/ui/components';
import styles from './CruciblesLockedNotice.module.scss';
import { toTourTargetProps } from '@sorrem-client/ui/shared/tour-targets';

/**
 * Shown in place of the Crucibles listing until the character completes the
 * House of Exchange's first commission: the house only shares where Crucibles
 * surface once it has their name.
 */
export function CruciblesLockedNotice(): JSX.Element {
    return (
        <div className={styles.lockedNotice} {...toTourTargetProps('crucibles-locked')}>
            <Icon icon="lock" size="large" className={styles.icon} />
            <h2 className={styles.title}>Where Crucibles Surface</h2>
            <p className={styles.description}>
                The houses of exchange know where Crucibles have surfaced across Sorrem, and they share it
                with the veil-touched they have on record. Complete the House of Exchange&apos;s commission,
                on your Overview, to be added to its records.
            </p>
        </div>
    );
}
